export const onlyNumber = (value: string): string => {
	if (typeof value === "number") return value;
	return value.replace(/\D/g, "");
};

export const toCurrency = (value: number): string => {
	if (value > 0) return "R$ " + (value / 100).toLocaleString("pt-BR");
	return "R$ " + value.toLocaleString("pt-BR");
};

export const removeNullProperties = (object: any) => {
	const result = { ...object };
	Object.keys(result).forEach((key) => {
		if (!result[key]) {
			delete result[key];
		}
	});
	return result;
};

export const removeAccentuation = (text: string): string => {
	return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const isIn = (val: string, ...arr: string[]) => {
	return !!arr.find((v) => v === val);
};

export const getErrorMessage = (error: unknown): string => {
	if (error instanceof Error) return error.message;
	return String(error);
};

export const removeNullPropertiesAndEmptyArrays = (obj: any): any => {
	Object.keys(obj).forEach(key => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length === 0)) {
            delete obj[key];
        } else if (typeof obj[key] === 'object') {
            removeNullPropertiesAndEmptyArrays(obj[key]);
        }
    });
    return obj;
}

export const remove_duplicated = (arr) => {
	if (!arr) return [];
	return arr.filter((value, index, self) =>
			index === self.findIndex((t) => (
				t.place === value.place && t.id === value.id
			))
	);
};

export function useFormatDistance(distance:number) {
    return `${Math.round(distance)}km`;
}

export function useSortNearbyCities(cities) {
    return cities.sort((a, b) => a.distance - b.distance);
}